'use client';
import { isFunction } from '@s7/utils';

/** Поддерживается ли AbortController в контексте исполнения */ const supportsAbortController = isFunction(globalThis.AbortController);

export { supportsAbortController };
//# sourceMappingURL=supportsAbortController.js.map
